import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class S3UploadService {
  /**
   * Upload a PDF to an AWS S3 pre-signed URL.
   * Uses native fetch API to avoid CORS issues with Angular HttpClient interceptors.
   * @param url  Pre-signed URL from backend
   * @param pdfBytes Uint8Array containing the PDF
   */
  uploadPdfToPresignedUrl(url: string, pdfBytes: Uint8Array): Observable<string> {
    return new Observable((observer) => {
      // Uint8Array is a valid BlobPart, but TypeScript needs the assertion
      const blob = new Blob([pdfBytes as BlobPart], { type: 'application/pdf' });

      // Use native fetch API to avoid Angular HttpClient interceptors and CORS issues
      // Only set Content-Type - fetch will automatically set Content-Length
      fetch(url, {
        method: 'PUT',
        body: blob,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`);
          }
          return response.text();
        })
        .then((text) => {
          observer.next(text);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }
}
